/* Pipit Reader page script. Runs only on the vf-pipit template. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('pp-config');
  if (!cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);
  document.body.classList.add('pp-page');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) { var v = (cents / 100).toFixed(2); return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- state ---------- */
  var state = { set: CFG.defaultSet, addons: {} };
  function variant(set) {
    set = set || state.set;
    for (var i = 0; i < CFG.variants.length; i++) if (CFG.variants[i].s === set) return CFG.variants[i];
    return CFG.variants[0];
  }
  function shortName() {
    for (var i = 0; i < CFG.sets.length; i++) if (CFG.sets[i].value === state.set) return CFG.sets[i].short;
    return state.set;
  }
  function total() {
    var t = variant().price;
    CFG.addons.forEach(function (a) { if (state.addons[a.id]) t += a.price; });
    return t;
  }
  function render() {
    var v = variant();
    var offer = $('#pp-offer');
    if (offer) offer.classList.toggle('is-single', state.set === CFG.singleSet);
    $$('[data-pp-set]').forEach(function (b) {
      var on = b.dataset.ppSet === state.set;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var now = $('[data-pp-price]'); if (now) now.textContent = money(v.price);
    var was = $('[data-pp-was]'); var save = $('[data-pp-save]');
    if (v.compare && v.compare > v.price) {
      if (was) { was.hidden = false; was.textContent = money(v.compare); }
      if (save) { save.hidden = false; save.textContent = 'Save ' + money(v.compare - v.price); }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; }
    $$('.pp-addon').forEach(function (b) { b.setAttribute('aria-pressed', state.addons[b.dataset.addon] ? 'true' : 'false'); });
    $$('[data-pp-total]').forEach(function (el) { el.textContent = money(total()); });
    $$('[data-pp-sticky-name]').forEach(function (el) { el.textContent = shortName(); });
    var vi = $('input[name="id"][data-pp-variant-input]'); if (vi) vi.value = v.id;
  }
  function scrollToOffer() {
    var box = document.getElementById('pp-offer');
    if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }
  $$('[data-pp-set]').forEach(function (b) {
    b.addEventListener('click', function () { state.set = b.dataset.ppSet; render(); showVariantMedia(); });
  });
  $$('[data-pp-select-set]').forEach(function (b) {
    b.addEventListener('click', function () { state.set = b.dataset.ppSelectSet; render(); showVariantMedia(); if (!b.closest('#pp-offer')) scrollToOffer(); });
  });
  $$('.pp-addon').forEach(function (b) {
    b.addEventListener('click', function () { state.addons[b.dataset.addon] = !state.addons[b.dataset.addon]; render(); });
  });

  /* ---------- cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function setCount(n) { $$('[data-pp-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function fetchCart() { return fetch(CFG.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(CFG.routes.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { throw new Error(CFG.strings.error); } if (!r.ok || j.status) throw new Error(j.description || j.message || CFG.strings.error); return j; }); });
  }
  function paintDrawer(j, open, btn) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { if (open) window.location.href = CFG.routes.cart; return; }
    if (j && j.sections) d.renderContents(j);
    if (typeof j.item_count === 'number') d.classList.toggle('is-empty', j.item_count === 0);
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open(btn);
  }
  function vipFirst() {
    var sheet = document.querySelector('.vf-root'), bag = drawer();
    if (!sheet || !bag || sheet.classList.contains('open')) return;
    var hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
    Object.keys(hide).forEach(function (k) { bag.style.setProperty(k, hide[k], 'important'); });
    var ticks = 0, tm = setInterval(function () {
      if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(function (k) { bag.style.removeProperty(k); }); }
    }, 100);
  }
  /* the free gifts follow the Reader: one of each gift and the gift code while a Pipit Reader is in the cart, none without it */
  var syncing = null;
  function syncGifts() {
    if (syncing) return syncing;
    syncing = fetchCart().then(function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_id === CFG.productId; });
      var code = (CFG.giftCode || '').toUpperCase();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var others = codes.filter(function (c) { return c.toUpperCase() !== code; });
      var hasCode = codes.length !== others.length;
      var updates = {}, change = false;
      if (hasMain) {
        CFG.gifts.forEach(function (g) {
          var lines = cart.items.filter(function (i) { return i.variant_id === g.id; });
          if (!lines.length) { updates[g.id] = 1; change = true; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; change = true; } });
        });
      } else {
        var giftIds = CFG.gifts.map(function (g) { return g.id; });
        cart.items.forEach(function (i) { if (giftIds.indexOf(i.variant_id) > -1 || (i.properties && i.properties._gift === 'pipit')) { updates[i.key] = 0; change = true; } });
      }
      var wantCode = hasMain && code;
      if (!change && (wantCode ? hasCode : !hasCode)) { setCount(cart.item_count); return cart; }
      var body = { updates: updates, sections: sectionIds(), sections_url: window.location.pathname };
      body.discount = others.concat(wantCode ? [CFG.giftCode] : []).join(',');
      return post('cart/update.js', body).then(function (j) { paintDrawer(j, false); setCount(j.item_count); return j; });
    }).catch(function () { return null; }).then(function (c) { syncing = null; return c; });
    return syncing;
  }
  function cartItems(inCart) {
    var v = variant();
    var items = [{ id: v.id, quantity: 1 }];
    CFG.addons.forEach(function (a) { if (state.addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
    CFG.gifts.forEach(function (g) { if (!inCart[g.id]) items.push({ id: g.id, quantity: 1, properties: { _gift: 'pipit' } }); });
    return items;
  }
  function addToCart(btn) {
    var errs = $$('[data-pp-error]');
    errs.forEach(function (e) { e.hidden = true; });
    var buttons = $$('[data-pp-add]');
    if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return Promise.resolve();
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      var d = drawer();
      if (d && d.setActiveElement) d.setActiveElement(btn);
      return fetch(CFG.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems(inCart), sections: sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }).then(function (res) {
      if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || CFG.strings.error);
      vipFirst();
      paintDrawer(res.body, false);
      return syncGifts().then(function (c) {
        return (c && typeof c.item_count === 'number' ? Promise.resolve(c) : fetchCart()).then(function (cc) {
          setCount(cc.item_count);
          paintDrawer({ item_count: cc.item_count }, true, btn);
        });
      });
    }).catch(function (e) {
      var msg = (e && e.message) ? e.message : CFG.strings.error;
      errs.forEach(function (el) { el.textContent = msg; el.hidden = false; });
      if (btn && !btn.closest('#pp-offer')) scrollToOffer();
    }).then(function () {
      buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  }
  $$('[data-pp-add]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      if (b.dataset.ppAddSet) { state.set = b.dataset.ppAddSet; render(); }
      addToCart(b);
    });
  });
  $$('[data-pp-open-cart]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var d = drawer();
      if (!d || typeof d.open !== 'function') return;
      e.preventDefault();
      if (!d.classList.contains('active')) d.open(b);
      Promise.all([fetch(CFG.routes.root + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }), fetchCart()]).then(function (res) {
        d.renderContents({ id: 0, sections: res[0] });
        paintDrawer({ item_count: res[1].item_count }, true, b);
      }).catch(function () {});
    });
  });
  syncGifts();
  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { clearTimeout(window.__ppSync); window.__ppSync = setTimeout(syncGifts, 300); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(syncGifts, 1400);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('cart-drawer [name="checkout"], cart-drawer a[href$="/checkout"]');
    if (!b || b.dataset.ppReady === '1') return;
    e.preventDefault(); e.stopImmediatePropagation();
    syncGifts().then(function () { var n = document.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.ppReady = '1'; n.click(); delete n.dataset.ppReady; });
  }, true);
  /* the shared proof row puts a comma between the two names; this page joins them with a space */
  $$('.pp-buy__proofrow .ceyla-rproof__text').forEach(function (p) {
    Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; });
  });

  /* ---------- gallery ---------- */
  var track = $('.pp-gallery__track');
  var slides = track ? $$('.pp-gallery__slide', track) : [];
  var thumbs = $$('.pp-thumb');
  var current = 0;
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
  }
  function mark(i) {
    current = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var t = thumbs[i];
    if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: reduced ? 'auto' : 'smooth' }); }
    slides.forEach(function (s, k) { var vv = s.querySelector('video'); if (!vv) return; if (k === i) { var pr = vv.play(); if (pr && pr.catch) pr.catch(function () {}); } else { vv.pause(); } });
  }
  function showVariantMedia() {
    var v = variant();
    if (!v.media) return;
    for (var i = 0; i < slides.length; i++) { if (String(slides[i].dataset.mediaId) === String(v.media)) { go(i, true); mark(i); return; } }
  }
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== current) mark(i); ticking = false; });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); mark(i); }); });
    var prev = $('.pp-gallery__nav--prev'), next = $('.pp-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);
  }

  /* ---------- shipping dates (local calendar days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' - ' + fmt(b); }
  var lastDay = '';
  function dates() {
    var now = new Date(); var key = now.toDateString();
    if (key === lastDay) return; lastDay = key;
    var s = CFG.ship;
    var shipped = addDays(now, s.ship), d1 = addDays(now, s.min), d2 = addDays(now, s.max);
    $$('[data-pp-date="order"]').forEach(function (el) { el.textContent = fmt(now); });
    $$('[data-pp-date="ship"]').forEach(function (el) { el.textContent = fmt(shipped); });
    $$('[data-pp-date="deliver"]').forEach(function (el) { el.textContent = fmtRange(d1, d2); });
    /* Christmas line: the last order day whose latest delivery still lands by Dec 24 */
    $$('[data-pp-deadline]').forEach(function (dl) {
      var eve = new Date(now.getFullYear(), 11, 24), last = addDays(eve, -s.max);
      if (now <= last) { dl.hidden = false; var t = dl.querySelector('[data-pp-deadline-date]'); if (t) t.textContent = fmt(last); } else { dl.hidden = true; }
    });
  }
  dates();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) dates(); });
  window.addEventListener('pageshow', dates);
  setInterval(dates, 60000);

  /* ---------- dialog ---------- */
  $$('[data-pp-dialog]').forEach(function (b) {
    b.addEventListener('click', function () { var dlg = document.getElementById(b.dataset.ppDialog); if (dlg && dlg.showModal) dlg.showModal(); });
  });
  $$('.pp-dialog').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var x = dlg.querySelector('.pp-dialog__x'); if (x) x.addEventListener('click', function () { dlg.close(); });
  });

  /* ---------- sticky bar and sample pill ---------- */
  var mainAtc = $('.pp-atc'), sticky = $('.pp-sticky'), closeSec = $('.pp-close');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    var atcVisible = true, closeVisible = false;
    var upd = function () { sticky.classList.toggle('is-on', !atcVisible && !closeVisible && mainAtc.getBoundingClientRect().top < 0); };
    new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
    if (closeSec) new IntersectionObserver(function (en) { closeVisible = en[0].isIntersecting; upd(); }).observe(closeSec);
    window.addEventListener('scroll', function () { if (!atcVisible) upd(); }, { passive: true });
  }
  var banner = $('.pp-disclose'), pill = $('.pp-pill');
  if (banner && pill && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { pill.classList.toggle('is-on', !en[0].isIntersecting); }).observe(banner);
  }

  /* ---------- try-it demo: tap a dot, it reads the line, then "your turn" ---------- */
  $$('.pp-demo').forEach(function (demo) {
    var tabs = $$('.pp-demo__tab', demo), pages = $$('.pp-page-card', demo);
    var turn = $('[data-pp-turn]', demo), note = $('[data-pp-voice-note]', demo);
    var synth = window.speechSynthesis, voice = null;
    function pickVoice() {
      if (!synth) return;
      var vs = synth.getVoices() || [];
      voice = vs.filter(function (v) { return /en-US/i.test(v.lang) && /female|samantha|aria|jenny|google us/i.test(v.name); })[0] || vs.filter(function (v) { return /en-US/i.test(v.lang); })[0] || vs.filter(function (v) { return /^en/i.test(v.lang); })[0] || null;
    }
    if (synth) { pickVoice(); if (typeof synth.onvoiceschanged !== 'undefined') synth.onvoiceschanged = pickVoice; }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        pages.forEach(function (p) { p.hidden = p.dataset.page !== t.dataset.page; });
        stop();
      });
    });
    var timers = [];
    function stop() {
      timers.forEach(clearTimeout); timers = [];
      if (synth) synth.cancel();
      $$('.pp-line', demo).forEach(function (l) { l.classList.remove('is-reading'); $$('.pp-w', l).forEach(function (w) { w.classList.remove('is-on'); }); });
      if (turn) turn.classList.remove('is-on');
    }
    function wrapWords(line) {
      var tx = $('.pp-line__t', line);
      if (!tx || tx.dataset.wrapped) return;
      tx.innerHTML = tx.textContent.split(/(\s+)/).map(function (w) { return /\s+/.test(w) ? w : '<span class="pp-w">' + w + '</span>'; }).join('');
      tx.dataset.wrapped = '1';
    }
    function read(line) {
      stop(); wrapWords(line);
      line.classList.add('is-reading');
      var words = $$('.pp-w', line), text = line.dataset.say || $('.pp-line__t', line).textContent;
      var per = Math.max(360, Math.min(700, 2600 / Math.max(words.length, 1)));
      var spoke = false;
      if (synth && window.SpeechSynthesisUtterance) {
        try {
          var u = new SpeechSynthesisUtterance(text);
          u.rate = 0.82; u.pitch = 1.05; u.lang = 'en-US'; if (voice) u.voice = voice;
          synth.speak(u); spoke = true;
        } catch (e) { spoke = false; }
      }
      if (!spoke && note) note.hidden = false;
      words.forEach(function (w, i) { timers.push(setTimeout(function () { w.classList.add('is-on'); }, 120 + i * per)); });
      timers.push(setTimeout(function () { line.classList.remove('is-reading'); if (turn) turn.classList.add('is-on'); }, 300 + words.length * per));
      timers.push(setTimeout(function () { if (turn) turn.classList.remove('is-on'); }, 2900 + words.length * per));
    }
    $$('.pp-line', demo).forEach(function (line) { line.addEventListener('click', function () { read(line); }); });
  });

  /* ---------- headlines light up word by word, as if read aloud ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('pp-js');
    $$('.pp-readout').forEach(function (h) {
      var walk = function (node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var sp = document.createElement('span'); sp.className = 'pp-rw'; sp.textContent = w; frag.appendChild(sp);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1) { walk(n); }
        });
      };
      walk(h);
      $$('.pp-rw', h).forEach(function (w, i) { w.style.transitionDelay = (i * 70) + 'ms'; });
    });
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.pp-readout, .pp-reveal').forEach(function (el) { rio.observe(el); });
    setTimeout(function () { $$('.pp-readout, .pp-reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 7000);
  }

  render();
})();
